import { LEDGER_KIND_BY_TYPE } from "../constants/paymentsLedger.constants";
import type { LedgerOperationKind, LedgerOperationType } from "../types/paymentsLedger.types";

/** Route base of the ledger view. Kept here so every module linking in agrees on one path. */
export const PAYMENTS_LEDGER_BASE_PATH = "/app/payments-ledger";

/** Deep link to the journal entries of one operation. */
export function buildLedgerPath(kind: LedgerOperationKind, operationId: string): string {
  return `${PAYMENTS_LEDGER_BASE_PATH}/${kind}/${operationId}`;
}

/**
 * Deep link from a raw ledger `operation_type` (what a wallet statement leg carries) to this view.
 *
 * Returns null for `FEE`, `ADJUST` and `REVERSE`: none of them names a browsable operation — `REVERSE` is the
 * mirror of another entry (the link belongs to the operation being reversed), and the other two are not
 * written by any runtime service today. A null must render as "no link", never as a broken one.
 */
export function ledgerPathForOperationType(
  operationType: LedgerOperationType,
  operationId: string,
): string | null {
  const kind = LEDGER_KIND_BY_TYPE[operationType];
  return kind ? buildLedgerPath(kind, operationId) : null;
}
